package com.happyukrainian.revision.kweb.config

import com.varabyte.kobweb.compose.css.VerticalAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.verticalAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.pt
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw

object HUColors {
    val blue = Color("#054D7F")
    val lightBlue = Color("#D3EDFF")
    val yellow = Color("#FEF1C4")
    val duckshell = Color("#FFFCF4")
    val dropshadowColor = Color("#99C9BF9B")
    val questionBackground = yellow

    val answerBackground = lightBlue
    val buttonBackground = blue
    val buttonBackgroundHover = Color("#006eba")
    val buttonBackgroundActive = blue
    val buttonTextColor = yellow
    val background = duckshell
    val cardTextColor = blue
}

val FlipContainerStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("perspective", "100vh")
        }
    }
}

val ButtonStyle = CssStyle {
    base {
        Modifier
            .background(HUColors.buttonBackground)
            .color(HUColors.buttonTextColor)
            .borderRadius(8.px)
            .fontSize(15.pt)
            .margin(top = 24.px)
            .padding(topBottom = 10.px, leftRight = 24.px)
            .styleModifier {
                property("white-space", "normal")
                property("height", "auto")
            }
    }

    hover {
        Modifier
            .background(HUColors.buttonBackgroundHover)
            .color(HUColors.buttonTextColor)
            .borderRadius(8.px)
    }

    active {
        Modifier
            .background(HUColors.buttonBackgroundActive)
            .color(HUColors.buttonTextColor)
            .borderRadius(8.px)
    }
    Breakpoint.SM {
        Modifier.width(20.vw).padding(topBottom = 32.px, leftRight = 24.px)
    }
    Breakpoint.MD {
        Modifier.width(10.vw).padding(topBottom = 8.px, leftRight = 66.px)
    }
}
